// eslint-disable-next-line import/no-internal-modules
import InputGroup from '@insided/deprecated-control/ui-components/InputGroup'
import { FunctionalComponent } from 'preact'
import { ColorsTheme, ColorsThemeCheckbox } from '../types'

export interface ColorCheckboxProps {
  colorKey: ColorsTheme['key']
  colorCheckbox: ColorsThemeCheckbox
  updatedStyling: Record<string, string | null>
  onChange: (newValue: string | null) => void
}

export const ColorCheckbox: FunctionalComponent<ColorCheckboxProps> = ({
  colorKey,
  colorCheckbox,
  updatedStyling,
  onChange
}) => (
  <div className='use-default'>
    <InputGroup
      inline
      title={colorCheckbox.title}
      type='checkbox'
      checked={updatedStyling[colorKey] === null ? 'checked' : ''}
      onChangeCheckbox={(event) => {
        onChange(event.target.checked ? null : updatedStyling[colorCheckbox.key])
      }}
    />
  </div>
)
